import { styled, Box } from '@withjoy/joykit';

// import marketingFonts, { MarketingFont } from './marketingFonts';

export const MarketingText = styled(Box)``;
